module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12 py-4"
  }, [(_vm.noTicketsSelected) ? _c('div', {
    staticClass: " text-center dark pb-3"
  }, [_vm._v("\n            Empty pax\n        ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w-100 fs-small"
  }, [(!_vm.noTicketsSelected || _vm.totalExtras > 0) ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (!_vm.noTicketsSelected) ? [_vm._l((_vm.bookingGenderPrices), function(personType) {
    return (personType.quantityToBook > 0 && _vm.audienceTypes) ? [_c('tr', [(personType.genderPriceType == 2 || personType.genderPriceType == 1 && personType.isExcludedFromBilling) ? _c('td', [_c('div', [_vm._v(_vm._s(personType.quantityToBook) + " x " + _vm._s(_vm.genderPriceObj(personType).name))]), _vm._v(" "), _c('div', {
      staticClass: "dark fs-small"
    }, [_vm._v(_vm._s(_vm.genderPriceObj(personType).description))])]) : _c('td', [_vm._v("Ticket")]), _vm._v(" "), (personType.productGenderPriceComponents.length == 0) ? _c('td', {
      staticClass: " text-right"
    }, [_vm._v(_vm._s((personType.genderPriceType == 2) ? personType.vatType + '%' : ''))]) : _vm._e(), _vm._v(" "), (personType.productGenderPriceComponents.length != 0) ? _c('td', {
      staticClass: " text-right"
    }, [_vm._v(_vm._s((personType.genderPriceType == 2) ? _vm.customPerPersonTaxes(personType.productGenderPriceComponents) : ''))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: " text-right"
    }, [_vm._v(_vm._s((personType.genderPriceType == 2 || personType.genderPriceType == 1 && personType.isExcludedFromBilling == false) ? _vm.formatPrice(_vm.showTicketPrice(personType) * personType.quantityToBook) + '€' : ''))])])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), (_vm.totalExtras > 0) ? [_vm._m(1), _vm._v(" "), _vm._l((_vm.getReservationCalculations.parcels), function(extra) {
    return (extra.itemType == 2 && extra.itemQuantity > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(extra.itemQuantity) + " x " + _vm._s(extra.itemNameDescription))]), _vm._v(" "), _c('td', {
      staticClass: " text-right"
    }, [_vm._v(_vm._s(extra.itemVATType) + "%")]), _vm._v(" "), _c('td', {
      staticClass: " text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(extra.itemTotalGrossprice)) + " €")])]) : _vm._e()
  })] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "taxWidth text-right"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticClass: "priceWidth text-right"
  }, [_vm._v("Price")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "font-weight-600 pt-2"
  }, [_vm._v("Extras")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-24aca612", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24aca612"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/CostList.vue
// module id = 1800
// module chunks = 0